import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: 'ホーム', href: 'home' },
  { label: '建てサポ事業', href: 'tatesapo' },
  { label: '整理収納事業', href: 'organizing' },
  { label: '会社概要', href: 'company' },
  { label: 'MVV', href: 'mvv' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-stone-200'
          : 'bg-transparent'
      }`}
    >
      <div className="px-8 h-18 flex items-center justify-between" style={{ height: '72px' }}>
        <button
          onClick={() => scrollToSection('home')}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/efa98eb8908ba68c03476b0cd87b8cc5/727e2ed769ca8d328240808d09ca791a.png"
            alt="会社ロゴ"
            className="h-12 object-contain"
          />
          <span
            className={`text-sm font-bold tracking-wide whitespace-nowrap transition-colors ${
              scrolled ? 'text-stone-800' : 'text-white'
            }`}
            style={{ fontFamily: 'Noto Serif JP' }}
          >
            合同会社べごま
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-7">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.href}
              onClick={() => scrollToSection(item.href)}
              className={`text-sm font-medium cursor-pointer transition-colors whitespace-nowrap tracking-wide ${
                scrolled
                  ? 'text-stone-600 hover:text-[#1e3a70]'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        <button
          className={`lg:hidden cursor-pointer w-8 h-8 flex items-center justify-center ${
            scrolled ? 'text-stone-700' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-stone-200 px-6 py-5 flex flex-col gap-5">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.href}
              onClick={() => scrollToSection(item.href)}
              className="text-sm font-medium text-stone-700 hover:text-[#1e3a70] text-left cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
